// Map only identified CRM products and explicit request values. No catalogue defaults.
const formats = {boxes_mailer_boxes: 'mailer', boxes_shipping_boxes: 'shipping_box', boxes_product_boxes: 'folding_carton'};
const text = value => typeof value === 'string' ? value.trim() : '';
export function opportunityQuoteInput(line) {
    const specs = line.specifications || {};
    const input = {businessUnit: 'empaque', type: formats[line.productId] || '', length: '', width: '', height: '', dimensionUnit: '',
        material: text(specs.material), printing: ({Interior: 'inside', Exterior: 'outside', 'Interior y exterior': 'both', 'Sin impresión': 'none'})[specs.print] || '',
        quantity: line.unit === 'unidades' && Number.isSafeInteger(line.quantity) && line.quantity > 0 ? String(line.quantity) : '',
        designs: '', destinationCountry: '', destinationPostalCode: '', neededBy: '', notes: ''};
    // Catalogue sizes include their unit; custom sizes have named axes. Unknown strings stay blank.
    const size = text(specs.size);
    const stock = size.match(/^(\d+(?:\.\d+)?)\s*[×x]\s*(\d+(?:\.\d+)?)\s*[×x]\s*(\d+(?:\.\d+)?)\s*(in|mm|cm)$/i);
    let dimensions;
    if (stock) dimensions = {values: stock.slice(1, 4), unit: stock[4].toLowerCase()};
    else {
        const entries = size.split(';').map(part => part.trim().split(':').map(v => v.trim()));
        if (entries.length === 4 && entries.every(([key, value, extra]) => extra === undefined && value && ['Largo', 'Ancho', 'Alto', 'Unidad'].includes(key)) && new Set(entries.map(([key]) => key)).size === 4) {
            const d = Object.fromEntries(entries);
            dimensions = {values: [d.Largo, d.Ancho, d.Alto], unit: d.Unidad};
        }
    }
    if (dimensions && ['in', 'mm', 'cm'].includes(dimensions.unit) && dimensions.values.every(v => Number.isFinite(Number(v)) && Number(v) > 0)) {
        input.dimensionUnit = dimensions.unit === 'cm' ? 'mm' : dimensions.unit;
        [input.length, input.width, input.height] = dimensions.values.map(v => dimensions.unit === 'cm' ? String(Number(v) * 10) : String(v));
    }
    return input;
}
